import { Box, Link } from '@mui/material'
import CompliancePlip from '../../../../components/CompliancePlip'
import dayjs from 'dayjs'
import { ComplianceStatus } from '../../../../types'
import useCustomer from '../../../../hooks/useCustomer'

interface BiologicalMonitoringProps {
  link: string
}

const BiologicalMonitoring = ({ link }: BiologicalMonitoringProps) => {
  const customer = useCustomer()
  const metadata = customer.customerMetadata

  const showLearnMore =
    metadata?.bio_compliance_status === ComplianceStatus.Inactive &&
    metadata?.bio_compliance_message !== 'BIO_NOT_TESTED'

  return metadata && (
    <Box>
      <div className='border-box'>
        <div>
          <CompliancePlip message='' className='dashboard-compliance' status={metadata.bio_compliance_status} />
        </div>
        <div className='compliance-message'>
          <p className='card-info'>{metadata.bio_message_long}</p>
          <Link className='small-text' href={link}>
            {showLearnMore ? 'Learn More' : 'View Details'}
          </Link>
        </div>
      </div>
      <div className='card-footer flex justify-between'>
        {metadata.bio_num_active_autoclaves > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{metadata.bio_num_active_autoclaves}</span>
            <span className="text-base">
              <CompliancePlip message='' className='dashboard-compliance small' status={metadata.bio_compliance_status} />
              Autoclave{metadata.bio_num_active_autoclaves > 1 ? 's' : ''}
            </span>
          </div>
        )}
        {metadata.bio_last_test_date && (
          <div className="center-text">
            <span className="block text-lg">{dayjs(metadata.bio_last_test_date).format('MMM D, YYYY')}</span>
            <span className="text-base">Last Activity</span>
          </div>
        )}
        {metadata.bio_remaining_tests > 0 && (
          <div className="center-text">
            <span className="block text-lg">{metadata.bio_remaining_tests}</span>
            <span className="text-base">Tests Left</span>
          </div>
        )}
      </div>
    </Box>
  )
}

export default BiologicalMonitoring